import signatureEmail from "../../../assets/jpg/email_signature.jpg";
import {
  ICollaborateur,
  Participation,
} from "../../../schemas/collaborateur/collaborateur.schema";
import { formatDate, formatPhoneWithoutPrefix } from "../../../utils";
import i18next from "i18next";

const dateLimitInscription = process.env.REACT_APP_DATE_LIMIT_INSCRIPTION;
const websiteUrl = process.env.REACT_APP_WEBSITE_URL;

export function generateInscriptionEmail_Etablissement(infos: {
  collaborateurInfo: ICollaborateur;
  participation: Participation;
}) {
  const { collaborateurInfo, participation } = infos;
  const t = i18next.t;
  
  return `<article>
      <p>${t("emails.content.greeting")}</p>

      <p>
        ${t("emails.content.newRegistration.intro")}
      </p>

      <p>${t("emails.content.newRegistration.summary")}</p>

      <p>${t("emails.content.newRegistration.firstName")} ${collaborateurInfo.prenom}</p>
      <p>${t("emails.content.newRegistration.lastName")} ${collaborateurInfo.nom}</p>

      <p>${t("emails.content.newRegistration.date")} ${formatDate(participation.dateParticipation, {
    hasDayName: true,
    hasYear: true,
  })} </p>
      <p>${t("emails.content.newRegistration.email")} ${collaborateurInfo.email} </p>
      <p>${t("emails.content.newRegistration.phone")} +49 ${formatPhoneWithoutPrefix(collaborateurInfo.phone)} </p>

      <p>
        ${t("emails.content.newRegistration.info")}
      </p>

      <p>${t("emails.content.regards")}</p>

      <p>${t("emails.content.team")}</p>
      <img
        src="${signatureEmail}"
        alt="signature_logo"
        width={100}
        height={100}
      ></img>
    </article > `;
}

export function generateAnnulationEmail_Etablissement(infos: {
  collaborateurInfo: ICollaborateur;
  participation: Participation;
}) {
  const { collaborateurInfo, participation } = infos;
  const t = i18next.t;
  
  return `<article>
      <p>${t("emails.content.greeting")}</p>

      <p>
        ${t("emails.content.cancellation.intro")}
      </p>

      <p>${t("emails.content.cancellation.summary")}</p>
      <p>${t("emails.content.cancellation.firstName")} ${collaborateurInfo.prenom}</p>
      <p>${t("emails.content.cancellation.lastName")} ${collaborateurInfo.nom}</p>

      <p>${t("emails.content.cancellation.date")} ${formatDate(participation.dateParticipation, {
    hasDayName: true,
    hasYear: true,
  })} </p>
      <p>${t("emails.content.cancellation.email")} ${collaborateurInfo.email} </p>
      <p>${t("emails.content.cancellation.phone")} +49 ${formatPhoneWithoutPrefix(collaborateurInfo.phone)} </p>

      <p>
        ${t("emails.content.cancellation.info")}
      </p>

      <p>${t("emails.content.regards")}</p>

      <p>${t("emails.content.team")}</p>
      <img
      src="${signatureEmail}"
      alt="signature_logo"
      width={100}
      height={100}
    ></img>
  </article > `;
}

export function generateModificationEmail_normalUpdate_Etablissement(infos: {
  collaborateurInfo: ICollaborateur;
  participation: Participation;
}) {
  const { collaborateurInfo, participation } = infos;
  const t = i18next.t;
  
  return `<article>
      <p>${t("emails.content.greeting")}</p>
      <p>
        ${t("emails.content.modification.intro")}
      </p>

      <p>${t("emails.content.modification.summary")}</p>
      <p>${t("emails.content.modification.firstName")} ${collaborateurInfo.prenom}</p>
      <p>${t("emails.content.modification.lastName")} ${collaborateurInfo.nom}</p>
      <p>
      ${t("emails.content.modification.date")} ${formatDate(
    participation?.dateParticipation,
    {
      hasDayName: true,
      hasYear: true,
    }
  )}
      </p>
      <p>${t("emails.content.modification.job")} ${participation?.metierTitle}</p>
      <p>${t("emails.content.modification.email")} ${collaborateurInfo.email}</p>
      <p>${t("emails.content.modification.phone")} +49 ${formatPhoneWithoutPrefix(collaborateurInfo.phone)}</p>

      <p>
        ${t("emails.content.modification.info")}
      </p>

      <p>${t("emails.content.regards")}</p>

      <p>${t("emails.content.team")}</p>
      <img
      src="${signatureEmail}"
      alt="signature_logo"
      width={100}
      height={100}
    ></img>
  </article > `;


}
